import { render, staticRenderFns } from "./RobotDashboard.vue?vue&type=template&id=1c668d3e&scoped=true"
import script from "./RobotDashboard.vue?vue&type=script&lang=js"
export * from "./RobotDashboard.vue?vue&type=script&lang=js"
import style0 from "./RobotDashboard.vue?vue&type=style&index=0&id=1c668d3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c668d3e",
  null
  
)

export default component.exports